<template>
  <div class="x-tablelist-view" data-automation="apply">
    <!-- 搜索行 -->
    <div class="search-line">
      <ux-searchOption
        :layout="layout"
        :data="filter"
        @search="seach"
        @resetsearch="resetsearch"
      ></ux-searchOption>
      <div class="apply-list-center">
        <ux-button v-if="this.$hasModule(2)" type="primary" icon="ux_icon_plus" @click="showAdd">
          {{ this.$t('HT.add') }}</ux-button
        >
        <!-- <span class="apply-list-total"
          >{{ $t('HT.orderOverview.total', { total: tableData.totalSize }) }}
        </span> -->
      </div>
    </div>
    <!-- 表格 -->
    <ux-table
      ref="table"
      maxHeight="100%"
      :hide-on-single-page="true"
      :data="tableData.list"
      :columns="columns"
      :total="tableData.totalSize"
      :size.sync="filter.size"
      :page.sync="filter.page"
      @changePage="changePage"
      @changeSize="changeSize"
      :emptyText="$t('HT.nodata')"
      layout="total, sizes, prev, pager, next"
    >
    </ux-table>
  </div>
</template>

<script>
import addApply from './template/addApply';
import bindProduct from './template/bindProduct';
import unbindApi from './template/unbindApi';
import approval from './template/approval';
import passDot from './template/passDot';
import secretKey from './template/secretKey';
import apiKey from './template/apiKey';
import ConfigurationModal from './template/configurationModal.vue';

export default {
  components: {
    addApply,
    bindProduct,
    unbindApi,
    approval,
    passDot,
    secretKey
  },
  data() {
    return {
      layout: [
        // 搜索项配置
        {
          type: 'input',
          key: 'name',
          width: '290px',
          right: true,
          placeholder: this.$t('HT.rules.addApply.name')
        },
        {
          type: 'button',
          text: this.$t('HT.reset'),
          // plain: true,
          plain: true,
          event: 'resetsearch'
        }
      ],
      columns: [
        // 表头数据
        {
          label: this.$t('HT.unbindApply.name'),
          tooltip: true,
          align: 'left',
          minWidth: 160,
          render: (h, params) => {
            return h(
              'span',
              {
                class: ['x-table-blue-btn'],
                on: {
                  click: () => {
                    this.$router.push({ path: `/applyInfo/${params.id}` });
                  }
                }
              },
              params.name
            );
          }
        },
        {
          label: this.$t('HT.bindAccessIp.appId'),
          prop: 'id',
          tooltip: true,
          width: 160,
          align: 'left',
          sortable: true
        },
        {
          label: 'API Key',
          prop: 'app_key',
          minWidth: 280,
          align: 'left',
          tooltip: true,
          render: (h, params) => {
            return h(apiKey, {
              props: {
                apikey: params.app_key || ''
              }
            });
          }
        },
        {
          label: 'Secret Key',
          prop: 'app_secret',
          width: 300,
          align: 'left',
          tooltip: true,
          render: (h, params) => {
            return h(secretKey, {
              props: {
                secret: params.app_secret || ''
              }
            });
          }
        },
        {
          label: this.$t('HT.productAll.createdBy'),
          prop: 'created_by',
          width: 160,
          align: 'left',
          tooltip: true
        },
        {
          label: this.$t('HT.last.revisiontime'),
          prop: 'modified_date',
          minWidth: 200,
          tooltip: true,
          align: 'left',
          sortable: true
        },
        {
          label: this.$t('HT.operation'),
          hidden: !this.$hasModule(2),
          width: 250,
          align: 'left',
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [this.$t('HT.manage'), this.$t('HT.Configuration'), this.$t('HT.delete')],
                colors: ['#0087ff', '#0087ff', '#F45C5C'],
                event: ['edit', 'configuration', 'del']
              },
              on: {
                edit: () => {
                  this.$router.push({ path: `/applyInfo/${params.id}` });
                },
                bind: () => {
                  this.showBind(params);
                },
                unbind: () => {
                  this.showUnbind(params);
                },
                del: () => {
                  this.$uxModal.show({
                    title: this.$t('HT.applyList.del'),
                    content: this.$t('HT.applyList.del.content'),
                    confirm: () => {
                      this.delList(params.id);
                    }
                  });
                },
                configuration: () => {
                  this.$uxModal.show({
                    title: this.$t('HT.Application.configuration'),
                    content: (h) => {
                      return h(ConfigurationModal, {
                        props: { ids: params.id }
                      });
                    },
                    confirm: (data) => {
                      let { data_center_ids, data_center_options, platform_ids } = data;
                      const idsList = [];
                      let allowDataCenterIndex = false;
                      platform_ids.forEach((item) => {
                        if (!item) {
                          allowDataCenterIndex = true;
                        }
                      });
                      // 不选择的话默认全选
                      if (data_center_ids.length === 0) {
                        data_center_options.forEach((item) => {
                          idsList.push(item.id);
                        });
                        data_center_ids = idsList;
                      }
                      let param = {
                        app_id: params.id,
                        data_center_ids: allowDataCenterIndex ? '' : data_center_ids.join(','),
                        platform_ids: platform_ids.join(',')
                      };
                      this.$api.apply.putDataCenter(param).then((res) => {
                        if (res.code === 10000) {
                          this.$uxModal.hide();
                          this.$uxMessage.success(this.$t('HT.Configuration.Successful'));
                        }
                      });
                    }
                  });
                }
              }
            });
          }
        }
      ],
      filter: {
        // 查询参数
        name: '', // 应用名称
        status: true, // 正常
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      },
      apiList: [],
      product: []
    };
  },
  created() {
    this.getList(this.filter);
  },
  mounted() {
    // this.getApiList();
    this.getProductList();
  },
  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.apply.getList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 重置搜索项
     */
    resetsearch() {
      console.log('重置');
      this.filter.name = '';
      this.seach();
    },
    /**
     * 添加列表
     * @param {Object} params 表单提交参数
     */
    addList(params) {
      this.$uxLoading.show();
      this.$api.apply.addList(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.addSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 修改列表
     * @param {Object} params 表单参数
     */
    putList(params) {
      this.$uxLoading.show();
      this.$api.apply.putList(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.editSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 审批应用
     * @param {Object} params 表单参数
     */
    approval(params) {
      this.$uxLoading.show();
      let method = params.flag ? 'pass' : 'refuse';
      this.$api.apply[method](params.id).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.approvalSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 删除列表
     * @param {String} id 唯一标识
     */
    delList(id) {
      this.$uxLoading.show();
      this.$api.apply.delList(id).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
          if (this.tableData.list.length === 1) {
            this.filter.page = this.filter.page - 1 ? this.filter.page - 1 : 1;
          }
          this.getList(this.filter);
        }
      });
    },

    /**
     * 新增-弹窗
     */
    showAdd() {
      const title = this.$t('HT.applyList.add');
      this.$modal.show({
        title,
        content: (h) => {
          return h(addApply);
        },
        confirm: (data) => {
          this.addList(data);
        }
      });
      // this.$uxModal.show({
      //     content: '添加应用',
      //     message: (h) => {
      //         return h(addApply, {
      //             on: {
      //                 confirm: (data) => {
      //                     this.addList(data);
      //                 }
      //             }
      //         });
      //     },
      // });
    },

    /**
     * 编辑
     * @param {Object} params 单行表格数据
     */
    showEdit(params) {
      const title = this.$t('HT.applyInfo.edit');

      this.$uxModal.show({
        title,
        content: (h) => {
          return h(addApply, {
            props: {
              data: params
            },
            on: {}
          });
        },
        confirm: (data) => {
          this.putList(data);
        }
      });
    },

    /**
     * 绑定
     * @param {Object} params 查询对象
     */
    showBind(params) {
      const title = this.$t('HT.applyList.bind');

      this.$uxModal.show({
        title,
        content: (h) => {
          return h(bindProduct, {
            props: { data: params, list: this.productList },
            on: {}
          });
        },
        confirm: (data) => {
          this.bind(data);
        }
      });
    },

    /**
     * 绑定
     * @param {Object} params 对象
     */
    bind(params) {
      this.$uxLoading.show();
      this.$api.apply.bind(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.bindSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 解绑
     * @param {Object} params 查询对象
     */
    showUnbind(params) {
      const title = this.$t('HT.applyList.unbind');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(unbindApi, {
            props: { data: params }
          });
        }
      });
    },

    /**
     * 重置
     * @param {Number} id 唯一标识
     */
    reset(id) {
      this.$uxLoading.show();
      this.$api.apply.reset(id).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.resetSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 获取api列表
     */
    // getApiList() {
    //     this.$uxLoading.show();
    //     this.$api.api.getList().then(res => {
    //         if (res.code == 10000) {
    //             this.apiList = res.data;
    //         }
    //     });
    // },

    /**
     * 获取产品列表
     */
    getProductList() {
      // this.$uxLoading.show();
      this.$api.product.getList().then((res) => {
        if (res.code == 10000) {
          this.productList = res.data;
        }
      });
    },

    /**
     * 搜索
     */
    seach() {
      this.filter.page = 1;
      this.getList(this.filter);
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getList(this.filter);
    }
  }
};
</script>

<style lang="scss" scoped>
.search-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .apply-list-center {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #8690aa;
    line-height: 20px;
  }
  .apply-list-total {
    margin-left: 20px;
  }
}
</style>
